import {CancelTokenSource} from 'axios';
import {AxiosCall} from '../axios';

export const getAllHolidaysList = async (
  options?: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  let url = `/admin/system/holidays`;

  if (options?.order) {
    url += `?order_by=${options?.order || ''}`;
  }

  if (options?.sort_by) {
    url += `&sort_by=${options?.sort_by || ''}`;
  }

  if (options?.year) {
    url += `&year=${options?.year}`;
  }
  return AxiosCall.get(url, cancelToken);
};

export const postSystemLevelHolidays = async (
  payload: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  const url = `/admin/system/holidays`;

  return AxiosCall.post(url, payload, cancelToken);
};

export const postGroupLevelHolidays = async (
  clinic_group_id: number,
  payload: any,
  clinicId?: number,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  let url = `/clinic-group/${clinic_group_id}/holidays`;

  if (clinicId) {
    url += `?clinic_id=${clinicId}`;
  }

  return AxiosCall.post(url, payload, cancelToken);
};

export const updateHolidayAtSystemLevel = async (
  id: number,
  payload: any
): Promise<any> => {
  const url = `/admin/system/holidays/${id}`;
  return AxiosCall.put(url, payload);
};

export const updateHolidayAtGroupLevel = async (
  id: number,
  clinic_group_id: number,
  payload: any,
  clinicId?: number
): Promise<any> => {
  let url = `/clinic-group/${clinic_group_id}/holidays/${id}`;
  // Optional query clinic_id kept for backward compatibility with access checks
  if (clinicId) {
    url += `?clinic_id=${clinicId}`;
  }
  return AxiosCall.put(url, payload);
};

export const deleteHolidayAtSystemLevel = async (id: number): Promise<any> => {
  const url = `/admin/system/holidays/${id}`;
  return AxiosCall.delete(url);
};

export const deleteHolidayAtGroupLevel = async (
  id: number,
  clinic_group_id: number,
  clinicId?: number
): Promise<any> => {
  let url = `/clinic-group/${clinic_group_id}/holidays/${id}`;
  if (clinicId) {
    url += `?clinic_id=${clinicId}`;
  }
  return AxiosCall.delete(url);
};

export const getGroupLevelHolidaysList = async (
  clinic_group_id: number,
  options?: any,
  cancelToken?: CancelTokenSource
): Promise<any> => {
  let url = `/clinic-group/${clinic_group_id}/holidays?include_system_holidays=${options.include_system_holidays}`;

  if (options?.order) {
    url += `&order_by=${options?.order || ''}`;
  }
  if (options?.clinic_id) {
    url += `&clinic_id=${options?.clinic_id}`;
  }
  if (options?.sort_by) {
    url += `&sort_by=${options?.sort_by || ''}`;
  }

  return AxiosCall.get(url, cancelToken);
};

export const getHolidaysInGuarantorPortal = ({
  clinic_id
}: {
  clinic_id: number;
}) => {
  return AxiosCall.get(
    `/guarantor/schedule-appointment/holidays?clinic_id=${clinic_id}`
  );
};
